export const appUat = {
  root: 'root',
}
